/** One category map for sale navigation and the filtered listing routes. */
export const saleCategories = [
  { slug: 'handtuecher', title: 'Handtücher', menuId: 1014, icon: 'towels' },
  { slug: 'bettwaesche', title: 'Bettwäsche', menuId: 1001, icon: 'bed' },
  { slug: 'bademaentel', title: 'Bademäntel', menuId: 1017, icon: 'robe' },
  { slug: 'wohndecken', title: 'Wohndecken', menuId: 1061, icon: 'blanket' },
  { slug: 'dekokissen', title: 'Dekokissen', menuId: 1007, icon: 'pillow' },
  { slug: 'vasen', title: 'Vasen', menuId: 1064, icon: 'vase' },
  { slug: 'tisch', title: 'Tisch', menuId: 1325, icon: 'table' },
  { slug: 'kueche', title: 'Küche', menuId: 33001337, icon: 'kitchen' },
]
export const saleCategoryHref = (slug: string) => `/sale/${slug}`
export const saleCategoryImage = (icon: string) => `/images/template/pictograms/${icon}.svg`
